(function () {
  if (window.__twColoringFormBound) return;
  window.__twColoringFormBound = true;

  var STORAGE_KEY = 'tw-coloring-mailing-list';

  function bindRoot(root) {
    var contactForm = root.querySelector('.coloring-contact-form');
    var customerForm = root.querySelector('.coloring-list-form');
    var optin = root.querySelector('[data-coloring-optin]');
    var emailInput = root.querySelector('[data-coloring-email]');
    var listEmail = root.querySelector('[data-coloring-list-email]');
    var bodyInput = root.querySelector('[data-coloring-body]');
    var success = root.querySelector('[data-coloring-success]');
    var listNote = root.querySelector('[data-coloring-list-note]');
    var download = root.querySelector('[data-coloring-download]');

    if (success) {
      root.classList.add('is-success');
      if (sessionStorage.getItem(STORAGE_KEY) === '1' && listNote) {
        listNote.hidden = false;
      }
      sessionStorage.removeItem(STORAGE_KEY);
      if (download) {
        window.setTimeout(function () {
          download.click();
        }, 400);
      }
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (!contactForm || !customerForm || !emailInput) return;

    contactForm.addEventListener('submit', function (event) {
      if (contactForm.getAttribute('data-coloring-ready') === '1') return;

      var wantsList = Boolean(optin && optin.checked);
      sessionStorage.setItem(STORAGE_KEY, wantsList ? '1' : '0');

      if (bodyInput) {
        bodyInput.value = wantsList
          ? 'Requested the wild horse coloring pages PDF. Also asked to join the mailing list.'
          : 'Requested the wild horse coloring pages PDF.';
      }

      if (!wantsList) return;

      event.preventDefault();
      if (listEmail) listEmail.value = emailInput.value;

      var submitContact = function () {
        contactForm.setAttribute('data-coloring-ready', '1');
        if (typeof contactForm.requestSubmit === 'function') {
          contactForm.requestSubmit();
        } else {
          contactForm.submit();
        }
      };

      fetch(customerForm.action, {
        method: 'POST',
        body: new FormData(customerForm),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .catch(function () {})
        .then(submitContact);
    });
  }

  document.querySelectorAll('[data-coloring-form]').forEach(bindRoot);
})();
